import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

export default function EmptyListingCard({ className = "", children }) {
  return (
    <Card
      sx={{
        maxWidth: 350,
        borderRadius: 2,
        position: "absolute",
        top: "200px",
        left: "50%",
        marginLeft: "-175px",
      }}
      className={className}
    >
      <CardContent>{children}</CardContent>
    </Card>
  );
}
